exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CheckBoxBar-module__checkbox-bar___1vi4L{background-color:#fff;padding:1.4rem 1.2rem;border-radius:5px;cursor:pointer;display:flex;gap:1rem;align-items:center;font-size:16px}.CheckBoxBar-module__checkbox-bar___1vi4L svg{color:#f1f0ea;font-size:22px}.CheckBoxBar-module__checkbox-bar___1vi4L.CheckBoxBar-module__active___3EPQe svg{color:#1e265c}", ""]);

// exports
exports.locals = {
	"checkbox-bar": "CheckBoxBar-module__checkbox-bar___1vi4L",
	"active": "CheckBoxBar-module__active___3EPQe"
};